import type { FC } from "react";

import appConfig from "config/appConfig";

import FacebookIcon from "assets/icons/colored/facebook.svg?react";
import GoogleIcon from "assets/icons/colored/google.svg?react";
import AppleIcon from "assets/icons/filled/apple.svg?react";
import { Button, DividerWithText } from "shared/uikit";
import { ButtonSizesEnum, ButtonVariantsEnum } from "shared/uikit/types";

interface SocialLoginProps {
	continueWith: string;
	loginWithApple: () => void;
	loginWithFacebook: () => void;
	loginWithGoogle: () => void;
	withDivider?: boolean;
}

const SocialLogin: FC<SocialLoginProps> = ({
	continueWith,
	loginWithApple,
	loginWithFacebook,
	loginWithGoogle,
	withDivider
}) => (
	<>
		<div className="flex flex-col gap-4">
			{appConfig.GLOBAL_CONSTANTS.ALLOW_GOOGLE_AUTH && (
				<Button
					size={ButtonSizesEnum.LG}
					variant={ButtonVariantsEnum.OUTLINED}
					startIcon={<GoogleIcon />}
					onClick={loginWithGoogle}
					id="continue-with-google"
				>
					{continueWith} Google
				</Button>
			)}
			{appConfig.GLOBAL_CONSTANTS.ALLOW_APPLE_AUTH && (
				<Button
					size={ButtonSizesEnum.LG}
					variant={ButtonVariantsEnum.OUTLINED}
					startIcon={<AppleIcon />}
					onClick={loginWithApple}
					id="continue-with-apple"
				>
					{continueWith} Apple
				</Button>
			)}
			{appConfig.GLOBAL_CONSTANTS.ALLOW_FACEBOOK_AUTH && (
				<Button
					size={ButtonSizesEnum.LG}
					variant={ButtonVariantsEnum.OUTLINED}
					startIcon={<FacebookIcon className="w-5" />}
					onClick={loginWithFacebook}
					id="continue-with-facebook"
				>
					{continueWith} Facebook
				</Button>
			)}
		</div>
		{withDivider && (appConfig.GLOBAL_CONSTANTS.ALLOW_GOOGLE_AUTH || appConfig.GLOBAL_CONSTANTS.ALLOW_APPLE_AUTH) && (
			<DividerWithText text="OR" className="my-6" />
		)}
	</>
);

export default SocialLogin;
